module.exports = __webpack_public_path__ + "static/gtm3_2-4aa1c399244a7e210b57028432411436.png";